<template>
  <v-dialog v-model="state" persistent width="400" scrollable>
    <v-card>
      <v-card-title>Khách hàng đã tồn tại</v-card-title>
      <v-card-text>
        Khách hàng đã tồn tại.
        <a :href="`/lead/${id}`" target="_blank" style="text-decoration: underline"
          >Xem thông tin chi tiết của khách này</a
        >
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="close" outlined color="primary">Ok</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    state: Boolean,
    id: String
  },
  watch: {
    state(state) {
      this.dialog = state
      if (!state) this.loading = false
    }
  },
  methods: {
    close() {
      this.$emit('close')
    }
  }
}
</script>
